export default "__VITE_ASSET__qKVZBh9$__"